module.exports = __webpack_public_path__ + "static/media/credits.ab38db2c.svg";